import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const ARTICLES_ARTICLE_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/articles',
        iconClass: 'fas fa-file-alt',
        name: '::Menu:Articles',
        layout: eLayoutType.application,
        requiredPolicy: 'Mandir.Articles',
      },
    ]);
  };
}
